import { ResyRoutingModule } from "./resy-routing.module";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from "../shared/shared.module";
import { NgModule } from "@angular/core";
import { VenuesComponent } from "../../resy-modul/components/venues/venues.component";
import { CreateCapacityForVenuesComponent } from "src/app/resy-modul/components/venues/create-capacity-for-venues/create-capacity-for-venues.component";
import { DeleteVenueComponent } from "src/app/resy-modul/components/venues/delete-venue/delete-venue.component";
import { AddHostComponent } from "../../resy-modul/components/hosts/add-host/add-host.component";
import { EditHostsComponent } from "../../resy-modul/components/hosts/edit-hosts/edit-hosts.component";
import { ReservationsComponent } from "../../resy-modul/components/reservations/reservations.component";
import {
  ApprovedReservationsComponent
} from "../../resy-modul/components/reservations/approved-reservations/approved-reservations.component";
import {
  ReservationDetailsComponent
} from "../../resy-modul/components/reservations/reservation-details/reservation-details.component";
import {
  AddDeclineCommentDialogComponent
} from "../../resy-modul/components/reservations/add-decline-comment-dialog/add-decline-comment-dialog.component";
import {
  ExportReservationsFormComponent
} from "../../resy-modul/components/reservations/export-reservations-form/export-reservations-form.component";
import {
  AddCapacityTemplateFormComponent
} from "../../resy-modul/components/venues/add-capacity-template-form/add-capacity-template-form.component";
import {
  ListEditCapacityTemplatesComponent
} from "../../resy-modul/components/venues/list-edit-capacity-templates/list-edit-capacity-templates.component";
import {
  ChooseCapacityTypeDialogComponent
} from "../../resy-modul/components/venues/choose-capacity-type-dialog/choose-capacity-type-dialog.component";
import {
  CapacityWarningsDialogComponent
} from "../../resy-modul/components/venues/capacity-warnings-dialog/capacity-warnings-dialog.component";
import {
  ContinueOrCreateNewCapacityDialogComponent
} from "../../resy-modul/components/venues/continue-or-create-new-capacity-dialog/continue-or-create-new-capacity-dialog.component";
import {
  DeleteGroupConfirmComponent
} from "../../resy-modul/components/venues/create-capacity-for-venues/delete-group-confirm/delete-group-confirm.component";
import { EditTableComponent } from "src/app/resy-modul/components/venues/create-capacity-for-venues/edit-table/edit-table.component";

@NgModule({
  declarations: [
    VenuesComponent,
    CreateCapacityForVenuesComponent,
    DeleteVenueComponent,
    AddHostComponent,
    EditHostsComponent,
    ReservationsComponent,
    ApprovedReservationsComponent,
    ReservationDetailsComponent,
    AddDeclineCommentDialogComponent,
    ExportReservationsFormComponent,
    AddCapacityTemplateFormComponent,
    ListEditCapacityTemplatesComponent,
    ChooseCapacityTypeDialogComponent,
    CapacityWarningsDialogComponent,
    ContinueOrCreateNewCapacityDialogComponent,
    DeleteGroupConfirmComponent,
    EditTableComponent
  ],
  imports: [
    ResyRoutingModule,
    DragDropModule,
    SharedModule
  ],
  exports: []


})

export class ResyModule {
}
